
import { Record } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { array_type, record_type, int32_type, bool_type, string_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { defaultOf, equals } from "../fable_modules/fable-library-js.5.13.0/Util.js";

const boot = (window.issieBridge).bootstrap;

export const platform = boot.platform;

export const osRelease = boot.osRelease;

export const arch = boot.arch;

export const electronVersion = boot.electronVersion;

export const chromeVersion = boot.chromeVersion;

export const staticDir = boot.staticDir;

export const userData = boot.userData;

export const documents = boot.documents;

export const cwd = boot.cwd;

export const isDev = boot.isDev;

export const hasDebugSwitch = boot.hasDebugSwitch;

export const hasWSwitch = boot.hasWSwitch;

export const logSwitch = boot.logSwitch;

/**
 * One subdirectory as main reports it: what is on the disk, not what it means. FilesIO turns
 * these facts into a ProjectDirectory.
 */
export class BrowseEntry extends Record {
    constructor(path, hasMarker, sheetCount, componentCount) {
        super();
        this.path = path;
        this.hasMarker = hasMarker;
        this.sheetCount = (sheetCount | 0);
        this.componentCount = (componentCount | 0);
    }
}

export function BrowseEntry_$reflection() {
    return record_type("Bridge.BrowseEntry", [], BrowseEntry, () => [["path", string_type], ["hasMarker", bool_type], ["sheetCount", int32_type], ["componentCount", int32_type]]);
}

/**
 * `exists` is false when the folder is not there, which the caller must tell apart from a folder
 * that is there and empty.
 */
export class BrowseResult extends Record {
    constructor(exists, entries) {
        super();
        this.exists = exists;
        this.entries = entries;
    }
}

export function BrowseResult_$reflection() {
    return record_type("Bridge.BrowseResult", [], BrowseResult, () => [["exists", bool_type], ["entries", array_type(BrowseEntry_$reflection())]]);
}

/**
 * The sidecar's WebSocket endpoint - (port, token) once it is listening, None while it is still
 * starting or after it has died. Poll at the moment of connecting; nothing pushes this.
 */
export function sidecarEndpoint() {
    const matchValue = window.issieBridge.sidecar.port();
    if (equals(matchValue, defaultOf())) {
        return undefined;
    }
    else {
        const v = matchValue;
        return [v.port, v.token];
    }
}

export const isWindows = platform === "win32";

export const isMac = platform === "darwin";

